import certificatesJson from "../../certificates.json";
import directoratesJson from "../../directorates.json";
import type { Certificate, Directorate } from "./types";

const directorateEnvelope = directoratesJson as { data: Directorate[] };
const certificateEnvelope = certificatesJson as { data: Certificate[] };

export const directorates = directorateEnvelope.data;
export const certificates = certificateEnvelope.data;

export const directorateIds = new Set(directorates.map((directorate) => directorate.id));
export const certificateIds = new Set(certificates.map((certificate) => certificate.id));
